export default class Header {
	constructor() {
		this.body = document.body;
		this.headerEl = document.querySelector('#wrapper-navbar');
		if (!this.headerEl) return;
		this.scrollPos = window.pageYOffset || document.body.scrollTop;
		this.events();
	}

	hasScrolled() {
		document.body.classList.add('has-scrolled');
	}

	notScrolled() {
		document.body.classList.remove('has-scrolled');
	}

	onScroll() {
		this.scrollPos = window.pageYOffset || document.body.scrollTop;
		this.scrollOffset = this.headerEl.offsetHeight;
		if (this.scrollPos >= this.scrollOffset) {
			this.hasScrolled();
		} else {
			this.notScrolled();
		}
	}

	events() {
		window.addEventListener('scroll', this.onScroll.bind(this), false);
	}
}

new Header();
